import { Controller } from "@hotwired/stimulus";
import { showOverlay, hideOverlay } from "../plugins/overlay";

// Connects to data-controller="counter"
export default class extends Controller {
  static values = { max: Number };

  static targets = [
    // Both total and qty hold the same value (the counter value)
    // but they have different purposes, so we need to assign both.
    "total",
    "qty",
    "plusBtn",
    "minusBtn",
  ];

  increment() {
    const total = parseInt(this.totalTarget.textContent);

    if (total + 1 > this.maxValue) {
      this.plusBtnTarget.disabled = "disabled";
      return;
    }

    this.totalTarget.textContent = total + 1;
    this.qtyTarget.value = total + 1;
  }

  decrement() {
    const total = parseInt(this.totalTarget.textContent);

    if (total - 1 < this.maxValue) {
      this.plusBtnTarget.removeAttribute("disabled");
    }

    if (total > 1) {
      this.totalTarget.textContent = total - 1;
      this.qtyTarget.value = total - 1;
    }
  }

  showOverlay(event) {
    showOverlay(event.submitter);
  }

  hideOverlay(event) {
    hideOverlay(event.target);
  }
}
